import {Item} from '../../API';

import {DataSource, FilterSchema} from "./DataSource";

import {listItems} from "./requests/listItems";

import {syncItemCreate, syncItemDelete, syncItemUpdate} from "../../sync/itemSync";

import {onCreateItem, onUpdateItem, onDeleteItem} from "../../graphql/subscriptions";
import { FullDataSourceDeps } from "../../platform/services/types/DataSourceDependencies";


export class ItemsDataSource extends DataSource<Item, Item, FullDataSourceDeps> {
    static modelName = 'Item';
    readonly _modelName = 'Item' as const;
    readonly _subscriptionGQLs = {
        onCreate: onCreateItem,
        onUpdate: onUpdateItem,
        onDelete: onDeleteItem,
    } as const;
    readonly workspaceId: string;

    constructor(deps: FullDataSourceDeps, workspaceId: string) {
        super(deps);
        
        this.workspaceId = workspaceId;
    }

    get syncHash() {
        return this.workspaceId.slice(0,6);
    }

    get syncQueryFilter() {
        return {
            workspaceId: {
                eq: this.workspaceId
            },
        }
    }

    onItemCreate = (serverItem: Item) => {
        const currentWsMST = this.deps.rootStore.view.workspace;
        if (serverItem.workspaceId === currentWsMST?.id) {
            syncItemCreate(currentWsMST, serverItem);
        }
    }

    onItemUpdate = (serverItem: Item) => {
        const currentWsMST = this.deps.rootStore.view.workspace;
        if (serverItem.workspaceId === currentWsMST?.id) {
            syncItemUpdate(currentWsMST, serverItem);
        }
    }

    onItemDelete = (serverItem: Item) => {
        const currentWsMST = this.deps.rootStore.view.workspace;
        if (serverItem.workspaceId === currentWsMST?.id) {
            syncItemDelete(currentWsMST, serverItem);
        }
    }

    getFilterDefaultValues(): {} {
        return {
        }
    }

    getFilterSchema(): FilterSchema<Item> {
        return {
            name: {
                type: 'client',
                apply: (item: Item) => item.name?.toLowerCase().indexOf(this.filterValues.name.toLowerCase()) !== -1,
            },
        }
    }

    loadGQLFetch() {
        return listItems(
            this.deps.dataClientService,
            this.deps.authService,
            this.workspaceId
        );
    };

    loadMoreGQLFetch(nextToken: string) {
        return listItems(
            this.deps.dataClientService,
            this.deps.authService,
            this.workspaceId, 
            nextToken
        );
    };

    getWsClient() {
        return this.deps.dataClientService.getWsClientForTable('items');
    };
}
